import React, { createContext } from 'react';

const QuestionContext = createContext({});
const HighLevelContext = createContext({});
const QuestionsContext = createContext({});
const PlatformContext = createContext({});

export { QuestionContext, HighLevelContext, QuestionsContext, PlatformContext };
